import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ResponsiveCarousel = ({ images, infiniteLoop, showIndicators, showThumbs, showStatus, showArrows, autoPlay, interval }) => {
  return (
    <Carousel 
      infiniteLoop={infiniteLoop} 
      showIndicators={showIndicators} 
      showStatus={showStatus} 
      showThumbs={showThumbs} 
      showArrows={showArrows} 
      autoPlay={autoPlay} 
      interval={interval}
      transitionTime={0}
      >
      {images.map((image, index) => (
        <div key={index}>
          <img src={image.src} alt={image.alt} />
          {/* <p className="legend">{image.caption}</p> */}
        </div>
      ))}
    </Carousel>
  );
};

export default ResponsiveCarousel;
